import { Box, IconButton, Image, Stack, Text } from "@chakra-ui/react";
import * as React from "react";
import { LuChevronLeft, LuChevronRight, LuImage } from "react-icons/lu";

interface ThumbnailCarouselProps {
  thumbnails: string[];
  title: string;
}

export const ThumbnailCarousel = ({
  thumbnails,
  title,
}: ThumbnailCarouselProps) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % thumbnails.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + thumbnails.length) % thumbnails.length,
    );
  };

  if (thumbnails.length === 0) {
    return (
      <Stack
        height="200px"
        bg="gray.100"
        align="center"
        justify="center"
        color="gray.400"
      >
        <LuImage size={32} />
        <Text color="gray.500" fontSize="sm">
          No preview available
        </Text>
      </Stack>
    );
  }

  return (
    <Box position="relative">
      <Image
        alt={title}
        width="100%"
        height={{ base: "400px", md: "200px" }}
        objectFit="cover"
        src={`${thumbnails[currentIndex]}-/format/auto/-/preview/1422x800/`}
      />
      {thumbnails.length > 1 && (
        <>
          <IconButton
            aria-label="Previous thumbnail"
            position="absolute"
            left={2}
            top="50%"
            transform="translateY(-50%)"
            onClick={prevSlide}
            colorPalette="gray"
            size="sm"
          >
            <LuChevronLeft />
          </IconButton>
          <IconButton
            aria-label="Next thumbnail"
            position="absolute"
            right={2}
            top="50%"
            transform="translateY(-50%)"
            onClick={nextSlide}
            colorPalette="gray"
            size="sm"
          >
            <LuChevronRight />
          </IconButton>
          <Stack
            position="absolute"
            bottom={2}
            left="50%"
            transform="translateX(-50%)"
            gap={1}
            direction="row"
          >
            {thumbnails.map((_, index) => (
              <Box
                key={index}
                w={2}
                h={2}
                rounded="full"
                bg={index === currentIndex ? "white" : "whiteAlpha.500"}
                transition="all 0.2s"
              />
            ))}
          </Stack>
        </>
      )}
    </Box>
  );
};
